<script lang="ts">
  import { Radio, Text } from "@getprovi/craft-svelte";

  export let availablePaymentMethods: string[];
  export let orderId: number;
  export let onPaymentMethodSelect: (order_id: number, paymentMethod: string) => void;

  let selectedPaymentMethod = availablePaymentMethods[0];
</script>

<div class="fizz-stack-24">
  <Text size="default" semibold>Select a payment method</Text>
  <span class="craft flex gap-24">
    {#each availablePaymentMethods as paymentMethod}
      <Radio
        bind:group={selectedPaymentMethod}
        on:change={() => onPaymentMethodSelect(orderId, paymentMethod)}
        checked={selectedPaymentMethod === paymentMethod}
        id={paymentMethod}
        label={paymentMethod}
        value={paymentMethod}
        testId="payment-method-radio-{paymentMethod.toLowerCase().replace(' ', '-')}"
      />
    {/each}
  </span>
</div>
